import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";

import * as actions from "../../../store/actions";
import constants from "../../../constants";

import Tabs from "../../../components/uiElements/navTabs/Tabs";
import { getSubscribedConciergeServiceListAction } from "../../../store/actions/dashboardActions";
import SubscribedPatientList from "./SubscribedPatientList/SubscribedPatientList";


const ConciergeService = ({ match, history }) => {
    const [currentTab, setCurrentTab] = useState();

  const { path } = match;
  const dispatch = useDispatch();

  const newSubscriptionRequestCount = useSelector(state => state.dashboard.conciergeService.countData.newSubscriptionRequestCount);
  const newMessagesCount = useSelector(state => state.dashboard.conciergeService.countData.newMessagesCount);

  const tabs = [
    {
      name: "ACCEPTED",
      value: <div>Subscribed Patients {newMessagesCount > 0 && <span className="is-dot-icon mb-0" />}</div>,
      to: path,
    },
    {
      name: "PENDING",
      value: <div>Requests {newSubscriptionRequestCount > 0 && <span className="is-dot-icon mb-0" />}</div>,
      to: path,
    },
  ];

  useEffect(() => {
    setCurrentTab("ACCEPTED");
    dispatch(getSubscribedConciergeServiceListAction())
  }, [])

  const handleTabChange = (name) => {
    setCurrentTab(name);
    dispatch(getSubscribedConciergeServiceListAction("", name));
  };

  return (
    <div>
      <div className="appointment-container m-n4">
        <Tabs 
        tabs={tabs} 
        activeTab={currentTab}
        onChange={handleTabChange}
        />
      </div>
      <div className="col-md-12 mt-5">
        <SubscribedPatientList tab={currentTab}/>
      </div>
    </div>
  );
};

const mapStoreToProps = ({ dashboard }) => ({
  patients: dashboard?.patients,
});

const mapDispatchToProps = dispatch => ({
  getPatients: () =>
    dispatch(
      actions.getAppointments([
        constants.APPOINTMENT_STATUS.requested,
        constants.APPOINTMENT_STATUS.accepted,
      ])
    ),
  searchPatient: searchData => dispatch(actions.searchPatient(searchData)),
  getAllPatientList: () => dispatch(actions.getAllPatientList()),
  getMyPatients: () => dispatch(actions.getDoctorPatientList()),
});

export default connect(mapStoreToProps, mapDispatchToProps)(ConciergeService);
